import { defineStyleConfig } from '@chakra-ui/react';

export const Button = defineStyleConfig({
  defaultProps: {},
  baseStyle: {
    fontWeight: '500',
    borderRadius: '8px',
    padding: '4px 12px',
    fontSize: '14px',
    lineHeight: '24px',
    textAlign: 'center',
    width: 'fit-content',
  },
  variants: {
    primary: {
      color: 'blue.700',
      backgroundColor: 'blue.100',
      _hover: {
        backgroundColor: 'blue.100',
        _disabled: {
          backgroundColor: 'gray.50',
        },
      },
      _disabled: {
        color: 'gray.500',
        backgroundColor: 'gray.50',
        fontWeight: '700',
      },
    },
    secondary: {
      color: 'white',
      backgroundColor: 'red.600',
      _hover: {
        backgroundColor: 'red.500',
        _disabled: {
          backgroundColor: 'gray.50',
        },
      },
      _disabled: {
        color: 'gray.200',
        backgroundColor: 'gray.50',
      },
    },
    tertiary: {
      color: 'gray.700',
      fontSize: '14px',
      fontWeight: 600,
      backgroundColor: 'transparent',
      border: '1px solid var(--chakra-colors-gray-300)',
      _hover: {
        backgroundColor: 'gray.50',
        _disabled: {
          backgroundColor: 'transparent',
        },
      },
      _disabled: {
        color: 'gray.200',
        backgroundColor: 'transparent',
      },
    },
    quaternary: {
      color: 'white',
      fontSize: '14px',
      fontWeight: 600,
      backgroundColor: 'blue.700',
      _hover: {
        backgroundColor: 'blue.700',
        _disabled: {
          backgroundColor: 'blue.200',
        },
      },
      _disabled: {
        color: 'gray.200',
        backgroundColor: '#ECF0F1',
      },
    },
    iconButton: {
      width: 'min-content',
      padding: '0!important',
      minWidth: 'min-content',
      _hover: {
        backgroundColor: 'initial',
      },
    },
    select: {
      color: '#1D1D1B',
      fontSize: '0.875rem',
      textAlign: 'start',
      backgroundColor: 'transparent',
      border: '1px solid #E7E7E7',
      padding: '6px 12px !important',
    },
    menuButton: {
      padding: '10px 18px 10px 18px',
      fontWeight: '600',
      color: 'green.700',
      backgroundColor: 'green.50',
      _hover: {
        backgroundColor: 'green.100',
        _disabled: {
          backgroundColor: 'gray.50',
        },
      },
      _disabled: {
        color: 'gray.500',
        backgroundColor: 'gray.50',
        fontWeight: '700',
      },
      '> span:not([class^="chakra-button"])': {
        flex: 'none',
      },
    },
  },
  sizes: {
    xs: {
      padding: '4px 12px',
      fontSize: '14px',
    },
    s: {
      padding: '8px 14px',
      fontSize: '14px',
    },
    m: {
      padding: '10px 18px',
      fontSize: '16px',
    },
    l: {
      padding: '12px 20px',
      fontSize: '16px',
    },
    xl: {
      padding: '16px 28px',
      fontSize: '18px',
    },
  },
});
